import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { delay, put, takeLeading } from 'redux-saga/effects';

import { fromDto as reservationFromDto } from '../../../models/adapters/ReservationSettingsAdapter';
import { waitBeforeFetch } from '../../../utils/FetchState';
import {
  fetchReservationSetting,
  FetchReservationSettingPayload,
  reservationSettingFetched,
  reservationSettingFetchFailed,
  ReservationSettingFetchResponsePayload,
} from '../../actions/setting/fetchReservationSetting';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function createReservationSettingFetchResponseAction(placeUuid: string, response): Action<ReservationSettingFetchResponsePayload> {
  const { error, reservationSetting } = response;
  const timestamp = moment();
  if (!error) {
    return reservationSettingFetched({ reservationSetting: reservationFromDto(reservationSetting), timestamp });
  }
  return reservationSettingFetchFailed({ placeUuid, timestamp });
}

function* fetchReservationSettingsSaga({ payload }: Action<FetchReservationSettingPayload>) {
  const token = yield getAuthenticationToken();
  const { placeUuid, fetchState } = payload;
  const milliseconds = waitBeforeFetch(fetchState);
  yield delay(milliseconds);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.getReservationSetting, token, { placeUuid });
  const action = createReservationSettingFetchResponseAction(placeUuid, response);
  yield put(action);
}

export default function* watchFetchReservationSettingsSaga() {
  yield takeLeading(fetchReservationSetting, fetchReservationSettingsSaga);
}
